import addMount from "../../core/addMount";
import OpeningHoursSidebar from "./OpeningHoursSidebar.entry";

addMount({ appName: "opening-hours-sidebar", app: OpeningHoursSidebar });
